import { replaceState } from '$app/navigation';

// time (deprecated)
export const millisecondsToDays = time => {
  return Math.floor(time / (1000 * 60 * 60 * 24));
};

export const millisecondsToHours = time => {
  return Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
};

export const millisecondsToMinutes = time => {
  return Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
};

export const millisecondsToSeconds = time => {
  return Math.floor((time % (1000 * 60)) / 1000);
};

// all in one
export const millisecondsToTime = (ms: number) => {
  if (!Number.isInteger(ms)) {
    return null;
  }

  const allocate = (msUnit: number) => {
    const units = Math.trunc(ms / msUnit);
    ms -= units * msUnit;
    return units;
  };

  return {
    days: allocate(86400000),
    hours: allocate(3600000),
    minutes: allocate(60000),
    seconds: allocate(1000),
    ms: ms // remainder
  };
};

// messages
export const formatMessageRoom = messageRoomRes => {
  let lastBucket = [];

  // there might be a better way to do this
  switch (messageRoomRes.lastBucket.length) {
    case 0:
      lastBucket = [];
      break;
    case 1:
      lastBucket = [...messageRoomRes?.lastBucket?.[0]?.messages];
      break;
    case 2:
      lastBucket = [
        ...messageRoomRes?.lastBucket?.[1]?.messages,
        ...messageRoomRes?.lastBucket?.[0]?.messages
      ];
      break;
    default:
      break;
  }
  return {
    _id: messageRoomRes._id,
    creator: messageRoomRes.creator,
    isLoading: false,
    lastBucket: lastBucket,
    participants: messageRoomRes.participants,
    createdAt: messageRoomRes.createdAt,
    blockedBy: messageRoomRes?.blockedBy || [],
    lastMessage:
      messageRoomRes?.lastBucket[0]?.messages[messageRoomRes?.lastBucket[0]?.messages?.length - 1],
    lastUpdated:
      messageRoomRes?.lastBucket[0]?.messages[messageRoomRes?.lastBucket[0]?.messages?.length - 1]
        ?.createdAt || messageRoomRes.createdAt
  };
};

export const getRandomNumber = (min, max) => {
  return Math.random() * (max - min) + min;
};

export function shuffle(arr: any[]) {
  let currentIndex = arr.length;
  let randomIndex: number;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [arr[currentIndex], arr[randomIndex]] = [arr[randomIndex], arr[currentIndex]];
  }

  return arr;
}

export const checkIfEmpty = (value, key) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'string') return value.length > 0;

  return true;
};

export function truncate(str: string, maxlength: number) {
  if (!str || str.length < maxlength) return str;
  return str.slice(0, maxlength - 1) + '…';
}

// export const linkify = (inputText: string) => {
// 	let elements = [];

// 	const regex =
// 		/(<a href=")?((https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)))(">(.*)<\/a>)?/gi;

// 	let matches = inputText.replace(regex, '{{LINK}}');

// 	console.log('elements', matches);
// 	return inputText;
// };

// export const test = (...args) => {
// 	console.log(args);
// 	return 'GG';
// };

export function parseDurationUserInput(durationString: string): {
  hours: number;
  minutes: number;
  seconds: number;
  stringified: string;
  totalSeconds: number;
} | null {
  const timeUnits = {
    h: 'hours',
    hr: 'hours',
    hour: 'hours',
    hours: 'hours',
    m: 'minutes',
    min: 'minutes',
    mins: 'minutes',
    minute: 'minutes',
    minutes: 'minutes',
    s: 'seconds',
    sec: 'seconds',
    secs: 'seconds',
    second: 'seconds',
    seconds: 'seconds'
  };

  const durationParts = durationString.match(/\d+\s*[a-z]+/gi); // Use regex to match numeric value and unit

  let hours = null;
  let minutes = null;
  let seconds = null;

  if (!durationParts) {
    return null;
  }

  durationParts.forEach(part => {
    const numericValue = parseInt(part.match(/\d+/)[0], 10);
    const unit = part.match(/[a-z]+/i)[0];

    if (isNaN(numericValue)) {
      return;
    }

    switch (timeUnits[unit]) {
      case 'hours':
        hours += numericValue;
        break;
      case 'minutes':
        minutes += numericValue;
        break;
      case 'seconds':
        seconds += numericValue;
        break;
      default:
        break;
    }
  });

  if (hours === null && minutes === null && seconds === null) {
    return null;
  }

  const stringified =
    (hours ? hours + ' hours ' : '') +
    (minutes ? minutes + ' minutes ' : '') +
    (seconds ? seconds + ' seconds' : '');

  const totalSeconds = hours * 60 * 60 + minutes * 60 + seconds;

  return {
    hours: hours ?? 0,
    minutes: minutes ?? 0,
    seconds: seconds ?? 0,
    stringified,
    totalSeconds
  };
}

export function formatSecondsToValidDurationUserInput(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const hoursString = hours > 0 ? `${hours} hour${hours !== 1 ? 's' : ''}` : '';
  const minutesString = minutes > 0 ? `${minutes} minute${minutes !== 1 ? 's' : ''}` : '';
  const secondsString =
    remainingSeconds > 0 ? `${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}` : '';

  let result = '';

  if (hoursString) {
    result += hoursString;
  }

  if (minutesString) {
    result += (result ? ' ' : '') + minutesString;
  }

  if (secondsString) {
    result += (result ? ' ' : '') + secondsString;
  }

  return result;
}

// TODO make the parsing better
export function parseRangeUserInput(s: string): { min: number | null; max: number | null } | null {
  if (!s) {
    return null;
  }

  const splitByComma = s.replaceAll(',', ' ').replaceAll('-', ' ');
  const split = splitByComma
    .split(' ')
    .map(v => v.trim())
    .filter(v => v);

  if (split.length > 2) {
    return null;
  }

  if (split.length === 1) {
    const min = +split[0];

    if (!min || min < 1) {
      return null;
    }

    return { min, max: null };
  }

  const min = +split[0];
  const max = +split[1];

  if (!min || min < 1 || !max || max < 1 || max < min) {
    return null;
  }

  return { min, max };
}
